import ColorPicker from "./ColorPicker";
export { Color } from "./color";
export { default as ColorBlock } from "./components/ColorBlock";
export * from "./interface";
export default ColorPicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/color-picker/es/index.js
// module id = 439
// module chunks = 0